import * as types from './types';
import FileDownload from 'react-file-download';
import { createAxiosInstance } from "../utils/helpers";
import { displayMessages } from "./common";
import { API_URL } from "./index";

/**
 * Get the data for report EVALUACION PROVEEDORES
 * @param {Number} page 
 */
export function getEvaluacionProveedor(page) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        
        const { reportes } = getState();

        axios.get(`${API_URL}/reportes/evaluacion_proveedores`, {
            params: {
                proveedor_id: reportes.getIn(['provider_evaluation', 'provider', 'id']),
                fecha_inicio: reportes.getIn(['provider_evaluation', 'initial_date']),
                fecha_fin: reportes.getIn(['provider_evaluation', 'final_date']),
                page,
                number_registers: reportes.getIn(['provider_evaluation', 'showRecords']), //showRecords
                order_by: reportes.getIn(['provider_evaluation', 'orderBy']),
                filters: reportes.getIn(['provider_evaluation', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS()
            }
        }).then(res => {
            return dispatch({
                type: types.OBTENER_EVALUACION_PROVEEDOR,
                payload: {
                    data: res.data.result,
                    accumulate: res.data.total_avg,
                    range_eval: res.data.range_eval,
                    totalRecords: res.data.total,
                    page
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}

/**
 * Get data for report MONTO CONTRATADO POR PROVEEDOR
 * @param {Number} page 
 */
export function getMontoContratadoProveedor(page) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const { reportes } = getState();

        axios.get(`${API_URL}/reportes/monto_contratado_proveedor`, {
            params: {
                proveedor_id: reportes.getIn(['contracted_amount_providers', 'provider', 'id']),
                fecha_inicio: reportes.getIn(['contracted_amount_providers', 'initial_date']),
                fecha_fin: reportes.getIn(['contracted_amount_providers', 'final_date']),
                page,
                number_registers: reportes.getIn(['contracted_amount_providers', 'showRecords']), //showRecords
                filters: reportes.getIn(['contracted_amount_providers', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS()
            }
        }).then(response => {
            return dispatch({
                type: types.OBTENER_MONTO_CONTRATADO_PROVEEDOR,
                payload: {
                    data: response.data.result,
                    totalRecords: response.data.total,
                    page
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}

/**
 * Get data for report MONTO CONTRATADO POR CENCO
 * @param {Number} page 
 */
export function getMontoContratadoCenco(page) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const { reportes } = getState();

        axios.get(`${API_URL}/reportes/monto_contratado_cenco`, {
            params: {
                responsable_id: reportes.getIn(['responsable', 'id']),
                cenco_id: reportes.getIn(['cenco', 'id']),
                fecha_inicio: reportes.getIn(['contracted_amount_cencos', 'initial_date']),
                fecha_fin: reportes.getIn(['contracted_amount_cencos', 'final_date']),
                page,
                number_registers: reportes.getIn(['contracted_amount_cencos', 'showRecords']), //showRecords
                filters: reportes.getIn(['contracted_amount_cencos', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS()
            }
        }).then(response => {
            return dispatch({
                type: types.OBTENER_MONTO_CONTRATADO_CENCO,
                payload: {
                    data: response.data.result,
                    totalRecords: response.data.total,
                    page
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}

/**
 * Get data for report CUMPLIMIENTO RESPONSABLE DE COMPRAS
 * @param {Number} page 
 */
// export function getCumplimientoResponsableCompras(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['compliance_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
//         const indexEtapa = filters.findIndex((f)=>f.column === 'evento');
//         if (indexEtapa >= 0) {
//             const evento = filters[indexEtapa];
//             const value = evento.value ? evento.value.split("-") : ["",""];
//             filters = [
//                 ...filters.slice(0, indexEtapa),
//                 {"column": "tipo_evento","operator": evento.operator,"value":value[0], "comparison":"number" },
//                 {"column": "evento","operator":evento.operator,"value":value[1], "comparison":"number" },
//                 ...filters.slice(indexEtapa+1)
//             ];
//         }

//         axios.get(`${API_URL}/reportes/cumplimiento_responsable_compras`, {
//             params: {
//                 responsable_id: reportes.getIn(['purchasing_manager', 'username']),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }



export function getCumplimientoResponsableCompras(page = 1) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const { reportes } = getState();
        let filters = reportes.getIn(['compliance_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();
        const indexEtapa = filters.findIndex((f)=>f.column === 'evento');
        if (indexEtapa >= 0) {
            const evento = filters[indexEtapa];
            const etapas = getState().common.getIn(['enums', 'etapas']).filter(e => e == evento.value)
            if (etapas.count()) {
                const value = etapas.keySeq().toArray().join('|')
                const operator = evento.operator === "!==" ? "NOT REGEXP" : "REGEXP"
                filters = [
                    ...filters.slice(0, indexEtapa),
                    {"column": "evento","operator": operator,"value":value, "comparison":"string" },
                    ...filters.slice(indexEtapa+1)
                ];
            }
        }

        axios.get(`${API_URL}/reportes/cumplimiento_responsable_compras`, {
            params: {
                responsable_id: reportes.getIn(['purchasing_manager', 'username']),
                page,
                number_registers: reportes.getIn(['compliance_purchasing_manager', 'showRecords']),
                filters,
                order_by: reportes.getIn(['compliance_purchasing_manager', 'orderBy']),
            }
        }).then(response => {
            return dispatch({
                type: types.OBTENER_CUMPLIMIENTO_RESPONSABLE_COMPRAS,
                payload: {
                    data: response.data.result,
                    page,
                    totalRecords: response.data.total
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}




// export function getReporteRadicados(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['radicados', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();

//         axios.get(`${API_URL}/reportes/radicados`, {
//             params: {
//                 usuario_id: reportes.getIn(['storage_manage', 'USUARIO']),
//                 fecha_inicio: reportes.get('initial_date'),
//                 fecha_fin: reportes.get('final_date'),
//                 order_by: reportes.getIn(['radicados', 'orderBy']),
//                 almacen: reportes.get('storage'),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_RADICADOS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }




export function getReporteRadicados(page = 1) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {

        const { reportes } = getState();
        let filters = reportes.getIn(['radicados', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();

        axios.get(`${API_URL}/reportes/radicados`, {
            params: {
                // usuario_id: reportes.getIn(['storage_manage', 'USUARIO']),
                fecha_inicio: reportes.getIn(['radicados', 'initial_date']),
                fecha_fin: reportes.getIn(['radicados', 'final_date']),
                order_by: reportes.getIn(['radicados', 'orderBy']),
                almacen: reportes.get('storage'),
                page,
                number_registers: reportes.getIn(['radicados', 'showRecords']),
                filters
            }
        }).then(response => {
            return dispatch({
                type: types.OBTENER_RADICADOS,
                payload: {
                    data: response.data.result,
                    page,
                    totalRecords: response.data.total
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}





// export function getGestionResponsableCompras(page) {
//     const axios = createAxiosInstance();
//     return (dispatch, getState) => {
//         const { reportes } = getState();
//         let filters = reportes.getIn(['manage_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();

//         axios.get(`${API_URL}/reportes/gestion_responsable_compras`, {
//             params: {
//                 fecha_inicio: reportes.get('initial_date'),
//                 fecha_fin: reportes.get('final_date'),
//                 order_by: reportes.getIn(['manage_purchasing_manager','orderBy']),
//                 tipo_solicitud: reportes.get('request_type'),
//                 page,
//                 number_registers: reportes.get('numberRegisters'),
//                 filters
//             }
//         }).then(response => {
//             return dispatch({
//                 type: types.OBTENER_GESTION_RESPONSABLE_COMPRAS,
//                 data: response.data.result,
//                 total: response.data.total
//             })
//         }).catch(err => displayMessages(dispatch, err));
//     }
// }



export function getGestionResponsableCompras(page = 1) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        const { reportes } = getState();
        let filters = reportes.getIn(['manage_purchasing_manager', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS();

        axios.get(`${API_URL}/reportes/gestion_responsable_compras`, {
            params: {
                fecha_inicio: reportes.getIn(['manage_purchasing_manager', 'initial_date']),
                fecha_fin: reportes.getIn(['manage_purchasing_manager', 'final_date']),
                order_by: reportes.getIn(['manage_purchasing_manager','orderBy']),
                tipo_solicitud: reportes.get('request_type'),
                page,
                number_registers: reportes.getIn(['manage_purchasing_manager', 'showRecords']), //showRecords
                filters
            }
        }).then(response => {
            return dispatch({
                type: types.OBTENER_GESTION_RESPONSABLE_COMPRAS,
                payload: {
                    data: response.data.result,
                    accumulate: response.data.acumulados,
                    page,
                    totalRecords: response.data.total
                }
            })
        }).catch(err => displayMessages(dispatch, err));
    }
}



/**
 * Change the amount of registers to show
 * @param {Number} number 
 */
export function changeNumberRegisterToShow(number, reportToGet) {
    return (dispatch) => {
        dispatch({
            type: types.MODIFICAR_NUMERO_REGISTROS_MOSTRAR,
            number,
            reportToGet
        });
        switch (reportToGet) {
            case 'provider_evaluation':
                return dispatch(getEvaluacionProveedor());
            case 'contracted_amount_providers':
                return dispatch(getMontoContratadoProveedor());
            case 'contracted_amount_cencos':
                return dispatch(getMontoContratadoCenco());
            case 'compliance_purchasing_manager':
                return dispatch(getCumplimientoResponsableCompras());
            case 'radicados':
                return dispatch(getReporteRadicados());
            case 'manage_purchasing_manager':
                return dispatch(getGestionResponsableCompras());
            default:
                console.error('no refresh');
        }
    }
}

/**
 * Set true or false, if the order is ascending or not by field.
 * @param {Object} field 
 * @param {String} reportToGet
 */
export function setOrderBy(field, reportToGet) {

    return (dispatch, getState) => {

        const currentOrder = getState().reportes.getIn([reportToGet, 'orderBy']);

        let newOrder = currentOrder.set('field', field.value);

        if (field === null){
            newOrder = newOrder.set('asc', false);
        }else{
            newOrder = newOrder.set('asc', !currentOrder.get('asc'));
        }

        dispatch({
            type: types.ORDENAR_REPORTES,
            payload: {
                orderBy: newOrder,
                reportToGet,
            }
        });

        dispatch(applyFilterCriterias());

    }
}

/**
 * Show or hide the modal filter.
 * @param {boolean} state 
 * @param {Object} tableCols 
 * @param {string} reportToGet 
 */
export function showHideModalFilter(state, tableCols, reportToGet) {
    return (dispatch, getState) => {
        if (!reportToGet) {
            reportToGet = getState().reportes.get('reportToGet');
        }
        return dispatch({
            type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_REPORTES,
            payload: { state, tableCols, reportToGet },
        });
    }
}

/**
 * Add row filter to state
 */
export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_REPORTES })
    }
}

/**
 * Delete row filter from state
 */
export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_REPORTES })
    }
}

/**
 * Select a row filter in modal
 * @param {Number} index 
 * @param {Boolean} checked 
 */
export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_REPORTES, payload: { index, checked } })
    }
}

/**
 * Modify an attribute of a row filter.
 * @param {Number} index 
 * @param {String} attr 
 * @param {*} value 
 */
export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_REPORTES, payload: { index, attr, value } })
    }
}

/**
 * Get data of a report with the information of state
 */
export function applyFilterCriterias() {
    return (dispatch, getState) => {
        const { reportes } = getState();

        dispatch({ type: types.APLICAR_CRITERIOS_FILTRADO_REPORTES });
        switch (reportes.get('reportToGet')) {
            case 'provider_evaluation':
                return dispatch(getEvaluacionProveedor());
            case 'contracted_amount_providers':
                return dispatch(getMontoContratadoProveedor());
            case 'contracted_amount_cencos':
                return dispatch(getMontoContratadoCenco());
            case 'compliance_purchasing_manager':
                return dispatch(getCumplimientoResponsableCompras());
            case 'radicados':
                return dispatch(getReporteRadicados());
            case 'manage_purchasing_manager':
                return dispatch(getGestionResponsableCompras());
            default:
                console.error('no refresh');
        }

    }
}

/**
 * Download a file from server
 * @param {String} ruta 
 * @param {Object} params 
 * @param {String} filename 
 */
export function downloadFile(ruta, params, filename) {
    const axios = createAxiosInstance();
    return (dispatch, getState) => {
        axios
            .get(`${API_URL}${ruta}`, { params, responseType: 'arraybuffer' })
            .then((res) => {
                FileDownload(res.data, filename);
            })
            .catch((err) => {
                const { data, status } = err.response;
                const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
                const obj = {
                    response: {
                        data: decodedString,
                        status
                    }
                };
                displayMessages(dispatch, obj);
            });
    }
}


export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_REPORTES, payload: { path, value } })
	}
}



// WEBPACK FOOTER //
// ./src/actions/reportes.js